// public route
import Login from './pages/authentication/Login'

// auth route
import Dashboard from './pages/administration/Dashboard'
import Chat from './pages/administration/Chat'
//order menu
import AddOrder from './pages/administration/Orders/AddOrder'
import AllListOrder from './pages/administration/Orders/AllListOrder'
import DivisionListOrder from './pages/administration/Orders/DivisionListOrder'
import DetailOrder from './pages/administration/Orders/Detail/DetailOrder'
import FormAddProductCatalog from './component/pages/Orders/Detail/Form/FormAddProductCatalog'
import FormAddProductManual from './component/pages/Orders/Detail/Form/FormAddProductManual'
import DetailPackageShipment from './pages/administration/Orders/DetailPackageShipment'
//request menu
import ProductRequest from './pages/administration/Request/ProductRequest'
import ProductQuotes from './pages/administration/Request/ProductQuotes'
//product menu
import AllListProduct from './pages/administration/Product/AllListProduct'
import BrandList from './pages/administration/Product/BrandList'
import CategoryList from './pages/administration/Product/CategoryList'
import CouponList from './pages/administration/Product/CouponList'
import SupplierList from './pages/administration/Product/SupplierList'
import WarehouseList from './pages/administration/Product/WarehouseList'
import AddProduct from './pages/administration/Product/AddProduct'
import BulkEditProduct from './pages/administration/Product/BulkEditProduct'
//fulfillment menu
import Inventory from './pages/administration/Fulfillment/Inventory'
//promotions menu
import PromoDeals from './pages/administration/Promotions/PromoDeals'
import Banners from './pages/administration/Promotions/Banners'
import CustomMenus from './pages/administration/Promotions/CustomMenus'
import Notifications from './pages/administration/Promotions/Notifications'
import CustomMenuCategories from './pages/administration/Promotions/CustomMenuCategories'
import Faq from './pages/administration/Promotions/Faq'
//user menu
import AllListUser from './pages/administration/Users/AllListUser'
import DetailUser from './pages/administration/Users/Detail/DetailUser'
import ReferralList from './pages/administration/Users/ReferralList'
import AgentList from './pages/administration/Users/AgentList'
import PartnerList from './pages/administration/Users/PartnerList'
import CommisionList from './pages/administration/Users/CommisionList'
import LimitationList from './pages/administration/Users/LimitationList'
//setting menu
import Setting from './pages/administration/Setting'
import CurrencyExchangeRates from './pages/administration/settings/CurrencyExchangeRates'
import CountryList from './pages/administration/settings/CountryList'
import ProvinceList from './pages/administration/settings/ProvinceList'
import CityList from './pages/administration/settings/CityList'
import PortList from './pages/administration/settings/PortList'
import Hscodes from './pages/administration/settings/Hscodes'
import CategoryRules from './pages/administration/settings/CategoryRules'
import ProductCategory from './pages/administration/settings/ProductCategory'
import InternationalShippingRateList from './pages/administration/settings/InternationalShippingRateList'
import SetRates from './pages/administration/settings/InternationalShippingRateList/SetRates'
import CommonAndGlobalSettings from './pages/administration/settings/CommonAndGlobalSettings'
import PaymentChannelsList from './pages/administration/settings/PaymentChannels'
import ReviewList from './pages/administration/settings/ReviewList'
import LanguageList from './pages/administration/settings/LanguageList'

// icon sidebar route
import {
  IconGauge,
  IconShoppingCart,
  IconBox,
  IconTruck,
  IconPhoto,
  IconUsers,
  IconSettings,
  IconAdjustmentsHorizontal,
  IconMessage
} from "@tabler/icons-react"
import DetailProduct from './pages/administration/Product/Detail/DetailProduct'

const routes = [
  {
    name: 'login-page',
    route: '/login',
    hasChildren: false,
    component: <Login />
  },
  {
    name: 'dashboard',
    route: '/',
    hasChildren: false,
    component: <Dashboard />
  },
]

const authRoutes = [
  {
    name: 'dashboard',
    route: '/dashboard',
    hasChildren: false,
    component: <Dashboard />,
    icon: <IconGauge stroke={1.5} size={18} />,
    type: 'route',
    children: []
  },
  {
    name: 'chats',
    route: '/chat',
    hasChildren: false,
    component: <Chat />,
    icon: <IconMessage stroke={1.5} size={18} />,
    type: 'route',
    children: []
  },
  {
    name: 'orders',
    route: null,
    hasChildren: true,
    component: null,
    icon: <IconShoppingCart stroke={1.5} size={18} />,
    type: 'group',
    children: [
      {
        name: 'all orders',
        route: '/order/all',
        component: <AllListOrder />
      },
      {
        name: 'add order',
        route: '/order/add',
        component: <AddOrder />
      },
      {
        name: 'sales division',
        route: '/order/division/sales',
        component: <DivisionListOrder />
      },
      {
        name: 'purchase & warehouse division',
        route: '/order/division/purchase',
        component: <DivisionListOrder />
      },
      {
        name: 'logistic division',
        route: '/order/division/logistic',
        component: <DivisionListOrder />
      },
      {
        name: 'aftersales division',
        route: '/order/division/aftersales',
        component: <DivisionListOrder />
      },
      {
        name: 'detail order',
        route: '/order/:order_id',
        component: <DetailOrder />
      },
      {
        name: 'add product catalog',
        route: '/order/:order_id/add-product/catalog/:order_currency',
        component: <FormAddProductCatalog />
      },
      {
        name: 'add product manual',
        route: '/order/:order_id/add-product/manual',
        component: <FormAddProductManual />
      },
      {
        name: 'detail package shipment',
        route: '/order/:order_id/package/:package_id',
        component: <DetailPackageShipment />
      },
    ]
  },
  {
    name: 'request',
    route: null,
    hasChildren: true,
    component: null,
    icon: <IconBox stroke={1.5} size={18} />,
    type: 'group',
    children: [
      {
        name: 'Product Quotes',
        route: '/request/sourcing-quote',
        component: <ProductQuotes />
      },
      {
        name: 'Sourcing Request',
        route: '/request/sourcing-request',
        component: <ProductRequest />
      },
    ]
  },
  {
    name: 'products',
    route: null,
    hasChildren: true,
    component: null,
    icon: <IconBox stroke={1.5} size={18} />,
    type: 'group',
    children: [
      {
        name: 'all products',
        route: '/product/all',
        component: <AllListProduct />
      },
      {
        name: 'add products manual',
        route: '/product/add',
        component: <AddProduct />
      },
      {
        name: 'suppliers',
        route: '/product/suppliers',
        component: <SupplierList />
      },
      {
        name: 'brands',
        route: '/product/brands',
        component: <BrandList />
      },
      {
        name: 'warehouses',
        route: '/product/warehouses',
        component: <WarehouseList />
      },
      {
        name: 'coupons',
        route: '/product/coupons',
        component: <CouponList />
      },
      {
        name: 'bulk edit products',
        route: '/product/bulk-edit',
        component: <BulkEditProduct />
      },
      {
        name: 'detail product',
        route: '/product/:product_id',
        component: <DetailProduct />
      },
      {
        name: 'Product Category',
        route: '/settings/product-category',
        component: <ProductCategory />
      },
    ]
  },
  {
    name: 'fulfillment',
    route: null,
    hasChildren: true,
    component: null,
    icon: <IconTruck stroke={1.5} size={18} />,
    type: 'group',
    children: [
      {
        name: 'inventory',
        route: '/fulfillment/inventory',
        component: <Inventory />
      },
    ]
  },
  {
    name: 'promotions',
    route: null,
    hasChildren: true,
    component: null,
    icon: <IconPhoto stroke={1.5} size={18} />,
    type: 'group',
    children: [
      {
        name: 'promo deals',
        route: '/promotions/promo-deals',
        component: <PromoDeals />
      },
      {
        name: 'banners',
        route: '/promotions/banners',
        component: <Banners />
      },
      {
        name: 'custom menu (educations)',
        route: '/promotions/custom-menu',
        component: <CustomMenus />
      },
      {
        name: 'notifications',
        route: '/promotions/notifications',
        component: <Notifications />
      },
      {
        name: 'custom menu categories',
        route: '/promotions/custom-menu-categories',
        component: <CustomMenuCategories />
      },
      {
        name: 'FAQ',
        route: '/promotions/faq',
        component: <Faq />
      },
    ]
  },
  {
    name: 'users',
    route: null,
    hasChildren: true,
    component: null,
    icon: <IconUsers stroke={1.5} size={18} />,
    type: 'group',
    children: [
      {
        name: 'all users',
        route: '/users/all',
        component: <AllListUser />
      },
      {
        name: 'detail user',
        route: '/users/:id',
        component: <DetailUser />
      },
      {
        name: 'referrals',
        route: '/users/referral',
        component: <ReferralList />
      },
      {
        name: 'agents',
        route: '/users/agent',
        component: <AgentList />
      },
      {
        name: 'partners',
        route: '/users/partner',
        component: <PartnerList />
      },
      {
        name: 'commisions',
        route: '/users/commision',
        component: <CommisionList />
      },
      {
        name: 'limitations',
        route: '/users/limitation',
        component: <LimitationList />
      },
    ]
  },
  {
    name: 'common & global settings',
    route: '/settings',
    hasChildren: true,
    component: <CommonAndGlobalSettings />,
    icon: <IconSettings stroke={1.5} size={18} />,
    type: 'group',
    children: [
      {
        name: 'All Settings',
        route: '/settings',
        component: <CommonAndGlobalSettings />
      },
      {
        name: 'Currency Exchange Rates',
        route: '/settings/currency',
        component: <CurrencyExchangeRates />
      },
      {
        name: 'Country List',
        route: '/settings/country-list',
        component: <CountryList />
      },
      {
        name: 'Province List',
        route: '/settings/province',
        component: <ProvinceList />
      },
      {
        name: 'City List',
        route: '/settings/city',
        component: <CityList />
      },
      {
        name: 'Port List',
        route: '/settings/port',
        component: <PortList />
      },
      {
        name: 'HS Codes',
        route: '/settings/hscodes',
        component: <Hscodes />
      },
      {
        name: 'Category Rules',
        route: '/settings/category-rules',
        component: <CategoryRules />
      },
      {
        name: 'International Shipping Rates',
        route: '/settings/international-shipping-rates',
        component: <InternationalShippingRateList />
      },
      {
        name: 'Set International Shipping Rates',
        route: '/settings/international-shipping-rates/set-rates',
        component: <SetRates />
      },
      {
        name: 'Payment Channels',
        route: '/settings/payment-channels',
        component: <PaymentChannelsList />
      },
      {
        name: 'Review List',
        route: '/settings/review',
        component: <ReviewList />
      },
      {
        name: 'Language List',
        route: '/settings/language-list',
        component: <LanguageList />
      },
    ]
  },
  {
    name: 'setting',
    route: '/setting',
    hasChildren: false,
    component: <Setting />,
    icon: <IconAdjustmentsHorizontal stroke={1.5} size={18} />,
    type: 'route',
    children: []
  },
]
export { routes, authRoutes }
